import { MediaService } from './media-service';

export default MediaService;
